"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPadlockLocked = function SvgIconPadlockLocked(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "padlock locked icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Padlock Locked Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.81 43.387h23.71V21.74H11.81v21.646zm3.608-29.315c0-5.278 3.407-8.824 8.246-8.824 4.84 0 8.247 3.546 8.247 8.824v3.546H15.418v-3.546zm22.162 3.546h-1.546v-3.546c0-7.623-5.178-12.947-12.37-12.947-7.191 0-12.369 5.324-12.369 12.947v3.546H9.75c-1.138 0-2.061.93-2.061 2.069v25.761c0 1.139.923 2.062 2.061 2.062h27.83a2.062 2.062 0 002.062-2.062V19.687a2.07 2.07 0 00-2.062-2.07z"
  }));
};

var _default = SvgIconPadlockLocked;
exports.default = _default;